<template>
  <div class="db-release-flow-detail">
    <Modal v-model="reviewModal" title="校验信息" width="1000">
      <div>
        <Table
          border
          highlight-row
          size="small"
          ref="reViewTable"
          :data="reviewResultData"
          :columns="reviewColumns"></Table>
      </div>
      <div slot="footer">
        <Button @click="reviewModal = false">关闭</Button>
      </div>
    </Modal>
    <Modal v-model="resultModal" title="执行结果" width="1000">
      <div style="font-size: 14px" class="db-release-result">
        <pre class="result-pre">{{ info.execute_result }}</pre>
      </div>
      <div slot="footer">
        <Button @click="resultModal = false">关闭</Button>
      </div>
    </Modal>
    <Modal v-model="refuseModal" title="驳回">
      <div>
        <Input v-model="refuseContent" style="width: 100%" type="textarea" :rows="4" placeholder="驳回原因（选填）" />
      </div>
      <div slot="footer">
        <Button type="error" :loading="refuseSubmitting" @click="refuse">驳回</Button>
        <Button @click="refuseModal = false">取消</Button>
      </div>
    </Modal>
    <Row :style="{marginBottom: '10px'}">
      <div :style="{float: 'left'}">
        <Button size="small" icon="ios-arrow-back" @click="$router.push({name: 'dbReleaseFlow', query: { page: $route.query.lastPage }})">返回列表</Button>
      </div>
    </Row>
    <Card shadow>
      <div class="content workflow-module-detail-content">
        <div class="main">
          <div>
            <Row style="margin-bottom: 10px">
              <Col :xs="24" :sm="24" :md="24" :lg="15">
                <Row class="title">
                  <h4 :style="{float: 'left'}">工作流详情</h4>
                </Row>
                <Alert v-if="infoError" type="warning" show-icon>获取数据失败</Alert>
                <div class="info-property" v-else>
                  <dl>
                    <dt>申请人</dt><dd v-if="info.applicant">{{ info.applicant.name ?
                    info.applicant.name : info.applicant.username }}</dd>
                  </dl>
                  <dl>
                    <dt>申请类型</dt><dd>{{ info.application_type_verbose }}</dd>
                  </dl>
                  <dl>
                    <dt>项目</dt><dd>{{ info.tenant_name }}</dd>
                  </dl>
                  <dl>
                    <dt>实例</dt><dd>{{ info.instance_name ? info.instance_name : info.instance_id }}</dd>
                  </dl>
                  <dl>
                    <dt>申请说明</dt><dd><span v-html="info.application_content"></span></dd>
                  </dl>
                  <dl>
                    <dt>执行 SQL</dt>
                    <dd>
                      <codemirror ref="detailCm" v-model="info.execute_sql" :options="detailCmOptions" class="dbFlowDetailSql"></codemirror>
                    </dd>
                  </dl>
                  <dl v-if="reviewResultData.length">
                    <dt>校验信息</dt><dd><a v-on:click="reviewModal = true">查看</a></dd>
                  </dl>
                  <dl v-if="info.status === 4">
                    <dt>执行结果</dt><dd><Button size="small" type="primary" @click="resultModal = true">查看结果</Button></dd>
                  </dl>
                  <dl v-if="info.status === 4">
                    <dt>执行状态</dt>
                    <dd>
                      <Tag v-if="info.execute_status === 2" color="green">执行成功</Tag>
                      <Tag v-else-if="info.execute_status === 3" color="red">执行失败</Tag>
                    </dd>
                  </dl>
                  <dl v-if="info.application_time">
                    <dt>申请时间</dt><dd>{{ moment(info.application_time).format('YYYY-MM-DD HH:mm:ss') }}</dd>
                  </dl>
                  <dl v-if="info.execute_time">
                    <dt>执行时间</dt><dd>{{ moment(info.execute_time).format('YYYY-MM-DD HH:mm:ss') }}</dd>
                  </dl>
                  <dl v-if="info.finished_time">
                    <dt>执行完成时间</dt><dd>{{ moment(info.finished_time).format('YYYY-MM-DD HH:mm:ss') }}</dd>
                  </dl>
                  <dl>
                    <dt>状态</dt>
                    <dd>
                      <Tag v-if="info.status_verbose === '已执行'" color="green">{{ info.status_verbose }}</Tag>
                      <Tag v-else-if="info.status_verbose === '执行中'" color="orange"><Icon type="ios-loading" size=18 class="demo-spin-icon-load" style="margin-right: 5px"></Icon>{{ info.status_verbose }}</Tag>
                      <Tag v-else-if="info.status_verbose === '驳回'" color="red">{{ info.status_verbose }}</Tag>
                      <Tag v-else color="blue">{{ info.status_verbose }}</Tag>
                    </dd>
                  </dl>
                  <dl v-if="info.can_execute">
                    <dt>操作</dt>
                    <dd>
                      <Button type="primary" size="small" @click="execute" style="margin-right: 8px" :loading="executeSubmitting">开始执行</Button>
                      <Button type="error" size="small" @click="refuseModal = true" :loading="executeSubmitting">驳回</Button>
                    </dd>
                  </dl>
                </div>
                <Row className="margin-top-10">
                  <Row class="title">
                    <h4>审批</h4>
                  </Row>
                  <Approves :approves="info.approves" approveType="db_release" :reFresh="this.handleReFresh" :status="info.status"/>
                </Row>
              </Col>
              <Col span="24" :md="{ span: 6, offset: 1 }">
                <div>
                  <div class="title" >
                    <h4>日志信息</h4>
                  </div>
                  <FlowLogs :logs = "info.logs"/>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
import moment from 'moment'
import { detailDbReleaseFlow, refuseDbReleaseFlow, executeDbReleaseFlow } from '@/api/workflow/db_release_flow'
import FlowLogs from '../components/Logs'
import Approves from '../components/Approves'
import { codemirror } from 'vue-codemirror-lite'
import 'codemirror/theme/monokai.css'
import 'codemirror/mode/sql/sql.js'
import 'codemirror/keymap/sublime.js'
import 'codemirror/addon/display/fullscreen.js'
import 'codemirror/addon/display/fullscreen.css'
import 'codemirror/addon/display/autorefresh'

export default {
  name: 'detail',
  components: {
    codemirror,
    FlowLogs,
    Approves
  },
  data () {
    return {
      moment: moment,
      detailCmOptions: {
        mode: {
          name: 'text/x-sql'
        },
        lineNumbers: false,
        styleActiveLine: true,
        indentUnit: 4,
        lineWrapping: true,
        keyMap: 'sublime',
        smartIndent: false,
        autoRefresh: true,
        autoCloseBrackets: true,
        cursorHeight: 0.85,
        height: '600px',
        readOnly: true,
        showCursorWhenSelecting: true,
        gutters: ['CodeMirror-linenumbers']
      },
      info: {},
      infoError: false,
      resultModal: false,
      timer: null,
      // 校验信息
      reviewModal: false,
      reviewResultData: [],
      reviewColumns: [
        {
          width: 90,
          title: 'ID',
          tooltip: true,
          align: 'center',
          key: 'ID'
        },
        {
          minWidth: 200,
          title: 'errormessage',
          align: 'center',
          key: 'errormessage'
        },
        {
          minWidth: 120,
          title: 'SQL',
          align: 'center',
          key: 'SQL'
        }
      ],
      // 驳回
      refuseModal: false,
      refuseSubmitting: false,
      executeSubmitting: false,
      refuseContent: ''
    }
  },
  created: function () {
    this.init()
  },
  beforeDestroy () {
    clearInterval(this.timer)
    this.timer = null
  },
  computed: {
    myCodeMirror () {
      let editor = this.$refs.myCm.editor
      editor.setSize('auto', '100px')
      return editor
    }
  },
  watch: {
    '$route' () {
      if (this.$route.params.id) {
        this.init()
      }
    },
    'info.status_verbose' () {
      if (this.info.status_verbose === '执行中') {
        this.setTimer()
      } else {
        clearInterval(this.timer)
        this.timer = null
      }
    }
  },
  methods: {
    // 初始化
    init () {
      this.getData()
    },
    // 获取工作流信息
    getData () {
      detailDbReleaseFlow(this.$route.params.id).then(res => {
        this.info = res.data
        this.infoError = false
        if (this.info.review_result_json) {
          this.reviewResultData = this.info.review_result_json
        }
      }).catch(res => {
        console.log(res.response)
        this.infoError = true
      })
    },
    // 处理刷新操作
    handleReFresh () {
      this.init()
    },
    // 执行
    execute () {
      this.executeSubmitting = true
      executeDbReleaseFlow(this.$route.params.id).then(res => {
        this.getData()
        this.$Notice.success({
          title: '操作成功！'
        })
        this.executeSubmitting = false
      }).catch(res => {
        this.executeSubmitting = false
        console.log(res.response)
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！'
          })
        }
      })
    },
    // 驳回
    refuse () {
      this.refuseSubmitting = true
      refuseDbReleaseFlow(this.$route.params.id, this.refuseContent).then(res => {
        this.getData()
        this.$Notice.success({
          title: '操作成功！'
        })
        this.refuseSubmitting = false
        this.refuseModal = false
      }).catch(res => {
        this.refuseSubmitting = false
        console.log(res.response)
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！'
          })
        }
      })
    },
    // 自动刷新
    setTimer () {
      clearInterval(this.timer)
      this.timer = null
      if (this.timer == null) {
        this.timer = setInterval(() => {
          this.getData()
        }, 5000)
      }
    }
  }
}
</script>

<style lang="less">
  @import '../../base.less';
  .dbFlowDetailSql {
    .CodeMirror-line {
      word-break: unset;
    }
  }
  .dbFlowDetailSql .CodeMirror {
    border: none;
    height: auto;
    max-width: 700px;
  }
  .dbFlowDetailSql .CodeMirror-scroll {
    max-height: 300px;
  }
  .dbFlowDetailSql .CodeMirror-vscrollbar {
    padding: 0;
    overflow-y: auto;
    max-height: 250px;
    padding-bottom: 5px;
    margin-top: 5px;
  }
  .dbFlowDetailSql .CodeMirror-vscrollbar::-webkit-scrollbar {
    width: 5px;
  }
  .dbFlowDetailSql .CodeMirror-vscrollbar::-webkit-scrollbar-track {
    border-radius: 5px;
    background-color: #eee;
  }
  .dbFlowDetailSql .CodeMirror-vscrollbar::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background: #dbdbdb;
  }
  .demo-spin-icon-load{
    animation: ani-demo-spin 1s linear infinite;
  }
  @keyframes ani-demo-spin {
    from { transform: rotate(0deg);}
    50%  { transform: rotate(180deg);}
    to   { transform: rotate(360deg);}
  }
  .demo-spin-col{
    height: 100px;
    position: relative;
    border: 1px solid #eee;
  }
  .result-pre {
    white-space: pre-wrap!important;
    word-wrap: break-word!important;
    *white-space:normal!important;
  }
  .db-release-result {
    padding: 0;
    overflow-y: auto;
    max-height: 600px;
    padding-bottom: 5px;
  }
  .db-release-result::-webkit-scrollbar {
    width: 5px;
  }
  .db-release-result::-webkit-scrollbar-track {
    border-radius: 5px;
    background-color: #eee;
  }
  .db-release-result::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background: #dbdbdb;
  }
  @media screen and (max-width:768px){
    .db-release-flow-detail .content .main .info-property dl dt{
      width:90px;
    }
  }
</style>
